import { pluralize } from '../pluralize';

const oneMinute = 1000 * 60;
const oneHour = oneMinute * 60;
const oneDay = oneHour * 24;

const monthNames = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
];

// TODO: Нужно не забыть добавить i18n
export function formatDistanceToNow(
    startDate: Date | string | number,
    currentTime: number = Date.now(),
): string {
    const date = new Date(startDate);
    const diffInTime = currentTime - date.getTime();
    const diffInMinutes = Math.round(diffInTime / oneMinute);
    const diffInHours = Math.round(diffInTime / oneHour);
    const diffInDays = Math.round(diffInTime / oneDay);

    if (diffInTime < oneMinute) {
        return 'Меньше минуты назад';
    }

    if (diffInTime < oneHour) {
        return pluralize(diffInMinutes, '%d минуту назад', '%d минуты назад', '%d минут назад');
    }

    if (diffInTime < oneDay) {
        return pluralize(diffInHours, '%d час назад', '%d часа назад', '%d часов назад');
    }

    if (diffInDays < 8) {
        return pluralize(diffInDays, '%d день назад', '%d дня назад', '%d дней назад');
    }

    return `${date.getDate()} ${monthNames[date.getMonth()]} ${date.getFullYear()}`;
}
